module.exports = "<p>\r\n  show works!\r\n</p>\r\n"